import { Box, Center, Flex, Stack, Text } from '@chakra-ui/react';
import { Card, tools, QrCodeIcon, ShareLinkIcon } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

interface ShareLinkCardProps {
  link: string;
  onLinkClick: () => void;
  onQrCodeClick: () => void;
  descriptionDom: React.ReactNode;
}

const ShareLinkCard = ({
  link,
  descriptionDom,
  onLinkClick,
  onQrCodeClick,
}: ShareLinkCardProps) => {
  const { t } = useTranslation();
  return (
    <Card>
      <Flex alignItems="center" gap="2.5" justifyContent="space-between" pb="3.5">
        <Flex gap="2.5">
          <Box fontSize="4xl">
            <ShareLinkIcon />
          </Box>
          <Stack gap="1">
            <Text fontSize="sm" fontWeight="semibold">
              {t('chat.shareLink')}
            </Text>
            <Text
              fontSize="xs"
              color="blue"
              cursor="pointer"
              onClick={() => {
                onLinkClick();
              }}
            >
              {tools.getShareUrlEllipsis(link, 42)}
            </Text>
          </Stack>
        </Flex>
        <Center fontSize="lg" mr="2.5" cursor="pointer" onClick={onQrCodeClick}>
          <QrCodeIcon />
        </Center>
      </Flex>
      {descriptionDom}
    </Card>
  );
};

const MemoizedShareLinkCard = memo(ShareLinkCard);
export { MemoizedShareLinkCard as ShareLinkCard };
